import { Grid } from '~components';
import {
  List,
  Item,
  Description,
  Text,
} from '../CompanyTypeInformation/styled';

function CompanyTypeCooperativeSa() {
  return (
    <Grid>
      <Text>
        Separe o estatuto social da sua empresa com a última atualização na
        junta comercial em formato PDF.
      </Text>
      <Description>
        O estatuto social também busca qualificar a sociedade, disciplinar as
        obrigações internas entre os sócios e as externas entre os sócios e
        terceiros. A diferença, no entanto, recai sobre o fato do estatuto
        social possuir sócios não contratantes entre si, pois é uma sociedade
        criada como instituição que possibilita a adesão de terceiros. Há três
        tipos de sociedades estatutárias:
      </Description>
      <List>
        <Item>Sociedade anônima (Lei 6.404/1976, art. 2º, § 2º);</Item>
        <Item>
          Sociedade em comandita por ações (art. 1090 do Código Civil);
        </Item>
        <Item>Sociedade cooperativa (Lei 5.764, art. 21).</Item>
      </List>
    </Grid>
  );
}

export default CompanyTypeCooperativeSa;
